import { useContext } from "react";
import { EmergencyContext } from "common/providers/EmergencyProvider";

export const useEmergencies = () => useContext(EmergencyContext);

export default useEmergencies;
